import { camelizeKeys } from 'humps'

import { handleRequestFailure } from '~/actions/request'
import getCustomerAPI from '~/utils/api/get-customer-api'
import HTTPError from '~/utils/http-error'

import { reportGroupedError } from '../utils/logger'

import type { SingleUseCredit } from '~/types'

export type CreditsActions =
  | {
      type: 'credits/LOAD_START'
    }
  | {
      type: 'credits/LOAD_SUCCESS'
      data: SingleUseCredit[]
    }
  | {
      type: 'credits/LOAD_FAIL'
    }

export const loadCredits = ({
  loadCreditsFunction = getCustomerAPI().getCredits,
  reload = false,
}: {
  loadCreditsFunction?: () => Promise<Response>
  reload?: boolean
} = {}) => {
  return async (dispatch, getState) => {
    const { credits } = getState()

    if (credits.loading) return
    if (!reload && credits.loaded) return

    dispatch({
      type: 'credits/LOAD_START',
    })

    try {
      const resp = await loadCreditsFunction()

      if (resp.ok) {
        const { data } = await resp.json()
        dispatch({
          type: 'credits/LOAD_SUCCESS',
          data: camelizeKeys(data),
        })
      } else {
        throw new HTTPError('failed: GET', resp, await resp.text())
      }
    } catch (err) {
      reportGroupedError('LoadCreditsError', err)
      dispatch(handleRequestFailure())
      dispatch({
        type: 'credits/LOAD_FAIL',
      })
    }
  }
}
